import React from 'react';
import {
  PictureAsPdf,
  Image,
  VideoFile,
  AudioFile,
  Description,
  FolderZip,
  TableChart,
  Slideshow,
  InsertDriveFile,
} from '@mui/icons-material';
import { getMimeIcon } from '../../utils/formatters';

const ICON_MAP = {
  PictureAsPdf,
  Image,
  VideoFile,
  AudioFile,
  Description,
  FolderZip,
  TableChart,
  Slideshow,
  InsertDriveFile,
};

export default function FileIcon({ mimeType, size = 'medium', sx = {} }) {
  const { icon, color } = getMimeIcon(mimeType);
  const IconComponent = ICON_MAP[icon] || InsertDriveFile;
  return <IconComponent fontSize={size} sx={{ color, ...sx }} />;
}
